import { render, staticRenderFns } from "./showVideo.vue?vue&type=template&id=44a3b004&scoped=true&"
import script from "./showVideo.vue?vue&type=script&lang=js&"
export * from "./showVideo.vue?vue&type=script&lang=js&"
import style0 from "./showVideo.vue?vue&type=style&index=0&id=44a3b004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a3b004",
  null
  
)

export default component.exports